import React, { lazy, Suspense } from 'react';

const LazyLoader = lazy(() => import('./Loader'));

const Loader = (props) => (
  <Suspense fallback={null}>
    <LazyLoader {...props} />
  </Suspense>
);

export default Loader;
